import caseSelector from './en/case-selector.json';
import caseViewer from './en/case-viewer.json';
import certification from './en/certification.json';
import common from './en/common.json';
import onboarding from './en/onboarding.json';
import validation from './en/validation.json';

export const translations = {
  en: {
    common,
    certification,
    caseSelector,
    caseViewer,
    onboarding,
    validation,
  },
};

export type TranslationKeys = typeof translations.en;
